import './CalenderDetailList.scss';



const CalenderDetailList = () => {

 const multipleData = [
    {
      title: "Hindu Calendar",
      description:
        "In Hindu Calendar, the day starts with local sunrise and ends with the next day local sunrise. Each Hindu day consists of five elements, called angas:",
      list: ["Tithi", "Nakshatra", "Yoga", "Karana", "Var"]
    },
    {
      title: "Panchang",
      description:
        "All five elements together are called Panchang. (Pancha = five, Ang = part).",
      list: []
    },
    {
      title: "Nakshatra List",
      description: "",
      list: [
        "Ashwini", "Bharani", "Krittika", "Rohini",
        "Mrigashira", "Ardra", "Punarvasu", "Pushya",
        "Ashlesha", "Magha", "Purva Phalguni", "Uttara Phalguni",
        "Hasta", "Chitra", "Swati", "Vishakha"
      ]
    }
  ];
  


return (
  <div className="calender-detail-list">
    {multipleData.map((section, idx) => (
      <div key={idx} className="calender-detail-list__block">
        <div className="calender-detail-list__header">
          <h2 className="calender-detail-list__title">{section.title}</h2>
        </div>
        <div className="calender-detail-list__content">
          <p>{section.description}</p>
          {section.list.length > 0 && (
            <ul>
              {section.list.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      </div>
    ))}
  </div>
);

}   
export default CalenderDetailList;